import { PropsWithChildren, useEffect, useState } from "react";
import { createPortal } from "react-dom";

const GatsbySafePortal: React.FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const [isClient, setClient] = useState(false);

  useEffect(() => {
    setClient(true);
  }, []);

  return isClient ? createPortal(children, document.body) : null;
};

export default GatsbySafePortal;
